import {
    FETCH_RISK_CONFIG,
    FETCH_RISK_CONFIG_FAIL,
    FETCH_RISK_CONFIG_SUCCESS,
    RESET_RISK
} from './actionTypes';

const initialState = {
    data: [],
    riskCategory: '',
    error: null,
    loading: false,
    loaded: false
};

export function riskReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_RISK_CONFIG: {
            return {
                ...state,
                riskCategory: action.payload.riskCategory,
                loading: true,
                loaded: false
            };
        }
        case FETCH_RISK_CONFIG_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                loaded: true,
                loading: false
            };
        }
        case FETCH_RISK_CONFIG_FAIL: {
            return {
                ...initialState,
                error: action.payload
            };
        }
        case RESET_RISK: {
            return initialState;
        }
        default:
            return state;
    }
}
